<!-- Временная отметка нового раздела в развёрнутом и свёрнутом меню. -->
<template>
  <span
    class="sidebar-new-badge"
    :class="{ 'sidebar-new-badge--collapsed': collapsed }"
    aria-label="Новый раздел"
  >
    <span v-if="!collapsed">new</span>
  </span>
</template>

<script>
export default {
  name: "AppSidebarNewBadge",

  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.sidebar-new-badge {
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  margin-left: 0;
  padding: 1px 6px;
  border-radius: 999px;
  background: #2bb39b;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
  text-transform: lowercase;
  overflow: hidden;
}

.sidebar-new-badge::after {
  content: "";
  position: absolute;
  inset: -30% auto -30% -45%;
  width: 35%;
  transform: skewX(-18deg);
  background: rgba(255, 255, 255, 0.24);
  animation: sidebar-new-badge-glint 5s ease-in-out infinite;
}

.sidebar-new-badge--collapsed {
  position: absolute;
  top: 7px;
  right: 7px;
  width: 7px;
  min-width: 7px;
  height: 7px;
  margin: 0;
  padding: 0;
  background: #ff7a45;
}

.sidebar-new-badge--collapsed::after {
  content: none;
}

@keyframes sidebar-new-badge-glint {
  0%,
  72% {
    left: -45%;
  }

  88%,
  100% {
    left: 120%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-new-badge::after {
    animation: none;
  }
}
</style>
